export default "__VITE_ASSET__DO3G6ei5__"